import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';

import { AddMultipleInput } from './types';
import { addMultipleAsync } from './slices';

export const addMultipleFollowings = async (
  data: AddMultipleInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(addMultipleAsync(data));

  return handleDispatchResult(res, onSuccess);
};
